import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";
import cx from 'classnames';
import { components } from "react-select";
import styles from "./subscriptionOption.module.css.json"; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

export default function (props) {
  var _props$data = props.data,
      licenseTier = _props$data.licenseTier,
      expiryDate = _props$data.expiryDate,
      objectID = _props$data.objectID;
  var label = "".concat(licenseTier.toUpperCase(), " (").concat(expiryDate.split("T")[0], ")");
  return /*#__PURE__*/React.createElement(components.Option, _extends({}, props, {
    className: styles.subscription
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.subscriptionId,
    title: objectID
  }, objectID), /*#__PURE__*/React.createElement("div", {
    className: styles.subscriptionLabel,
    title: label
  }, label));
}
export var SubscriptionValue = function SubscriptionValue(props) {
  var _ref = props.getValue() || [],
      _ref2 = _slicedToArray(_ref, 1),
      selectValue = _ref2[0];

  var text = "";

  if (selectValue) {
    text = "".concat(selectValue.objectID, " ").concat(selectValue.licenseTier.toUpperCase(), " (").concat(selectValue.expiryDate.split("T"), ")");
  }

  return /*#__PURE__*/React.createElement(components.ValueContainer, props, /*#__PURE__*/React.createElement("div", {
    className: cx(styles.subscriptionValue, _defineProperty({}, styles.placeholder, !text)),
    title: text
  }, text || props.selectProps.placeholder));
};